var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("403 Forbidden")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.translation(4425)))]),_vm._v(" "),_c('br'),_vm._v("\n  Ga terug of login met een andere gebruiker\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }